export default __webpack_public_path__ + "static/media/fastingworkout@3x.e9eafbaa.jpg";